import Service from "../Services/service";

export async function ScreenListHooks(searchTerm, sortBy, sortDescending, pageNumber, pageSize) {
    var userId = localStorage.getItem("userId")
    var data;
    await Service.getdata("Screen/GetAll?searchTerm=" + searchTerm + "&sortBy=" + sortBy + "&sortDescending=" + sortDescending + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize +"&userId=" + userId).then((res) => {
        data = res.data;
    });
    return data;
}

export async function ScreenGetByIdHooks(id) {
    var data;
    await Service.getdatabyId("Screen/GetById?id=",id).then((res) => {
        data = res.data;
    });
    return data;
}


export async function CreateScreenHooks(formData) {
    var data;
    await Service.createorupdate("Screen/CreateOrUpdate", formData)
        .then(res => {
            //  setApiResponse(res.data); // Set the API response in state  
            data = res.data;
        })
        .catch(error => {
            // Handle error if API call fails
            console.error("API Error:", error);

        });
    return data;
}